import { ModalForm } from "modules/app/styles"
import { ModalBody } from "reactstrap"
import { UploadImage } from "./styles"
import { useDropzone } from 'react-dropzone';
import { FiImage } from "react-icons/fi";
import { LiaUploadSolid } from 'react-icons/lia'
import { toast } from "react-toastify";

const UploadFromFile = ({ handleSubmissionOfMedia }) => {
  const {
    acceptedFiles,
    getRootProps,
    getInputProps
  } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/gif': []
    },
    onDrop: (file) => {
      const acceptedTypes = ['image/jpeg', 'image/png', 'image/gif'];

      if (!file.length || !acceptedTypes.includes(file[0].type)) {
        toast.error('Please upload an image with one of the following extensions: JPG, JPEG, PNG, GIF.')
      } else {
        handleSubmissionOfMedia(false, file[0])
      }
    },
    multiple: false,
    // validator: imageValidator
  });

  return (
    <>
      <ModalBody>
        <ModalForm>
          <div className='title'>Change Cover Image</div>

          <div className='my-auto d-flex flex-column' style={{ height: '90%' }}>
            <div className='font-weight-600 my-4' style={{ fontSize: '1.14rem' }}>Upload from file</div>
            <UploadImage>
              {/* <Dropzone accept={'image/png'} multiple={false} onDrop={acceptedFiles => { handleSubmissionOfMedia(false, acceptedFiles[0]); setImage(acceptedFiles[0]) }}>
                {({ getRootProps, getInputProps }) => {
                  return ( */}
              <div className="dropzone-style" {...getRootProps()}>
                <div className="body">
                  {acceptedFiles?.length ? (
                    <>
                      <div>
                        <FiImage />
                        <p>{acceptedFiles[0]?.path}</p>
                      </div>
                    </>
                  ) : (<>
                    <input onDrop={() => console.log('drop')} {...getInputProps()} />
                    <LiaUploadSolid />
                    <div>Drag & drop image here</div>
                    <p>(or click here)</p>
                    <div>Maximum 3MB</div>
                    <p>Recommended image size - 800px height x 1200px width</p>
                    <p>Accepted image file formats are .jpg, .png, .gif</p>
                  </>)}
                </div>
              </div>
              {/* )
                }}
              </Dropzone> */}
            </UploadImage>
          </div>
        </ModalForm>
      </ModalBody>
    </>
  )
}
export default UploadFromFile